import React, { useId } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import FieldShell from './FieldShell';

/**
 * AppTextareaField — wraps PrimeReact InputTextarea with FieldShell.
 */
const AppTextareaField = ({
    label,
    value,
    onChange,
    placeholder,
    helperText,
    errorMessage,
    required = false,
    invalid = false,
    disabled = false,
    readOnly = false,
    fluid = true,
    rows = 4,
    className = '',
    trailing,
    ...rest
}) => {
    const autoId = useId();
    const id = rest.id || autoId;

    const inputCls = [
        'fk-input',
        invalid && 'fk-input--invalid',
        disabled && 'fk-input--disabled',
        readOnly && 'fk-input--readonly',
    ].filter(Boolean).join(' ');

    return (
        <FieldShell
            label={label}
            htmlFor={id}
            required={required}
            helperText={helperText}
            errorMessage={errorMessage}
            invalid={invalid}
            disabled={disabled}
            readOnly={readOnly}
            fluid={fluid}
            className={className}
            trailing={trailing}
        >
            <div className={inputCls}>
                <InputTextarea
                    id={id}
                    value={value ?? ''}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                    rows={rows}
                    {...rest}
                />
            </div>
        </FieldShell>
    );
};

export default AppTextareaField;
